module.exports = __webpack_public_path__ + "static/media/savio6.f376e817.jpg";